import { push } from "react-router-redux";
import jwtDecode from "jwt-decode";

import { getApiBaseUrl, fetchApi } from "containers/ApiUrls";
import { handleLogout } from "routes/Login/module";
import {
  GOOGLE_CLIENT_ID,
  VALIDATION_CREDENTIAL_ERROR_MSG,
  INACTIVITY_MSG
} from "constants/constants";
import { setSupportUser, clearSupportUser } from 'common/utils';
// ------------------------------------
// Constants
// ------------------------------------
export const CLEAR_STATE = "CLEAR_STATE";
export const CLEAR_AUTHENTICATION = "AUTH.CLEAR_AUTHENTICATION";
export const SET_AUTHENTICATION = "AUTH.SET_AUTHENTICATION";
export const SET_AUTHENTICATION_FAILED = "AUTH.SET_AUTHENTICATION_FAILED";
export const UPDATE_CHECK_AUTH_INTERVAL_ID =
  "AUTH.UPDATE_CHECK_AUTH_INTERVAL_ID";
export const NEW_TOKEN_IS_FETCHING = "AUTH.NEW_TOKEN_IS_FETCHING";
export const NEW_TOKEN_RECEIVED = "AUTH.NEW_TOKEN_RECEIVED";

// ------------------------------------
// Actions
// ------------------------------------
export function clearState() {
  return {
    type: CLEAR_STATE
  };
}
export function clearAuthentication() {
  return {
    type: CLEAR_AUTHENTICATION
  };
}

export function setAuthentication() {
  return {
    type: SET_AUTHENTICATION
  };
}
export function setAuthenticationFailed() {
  return {
    type: SET_AUTHENTICATION_FAILED
  };
}
export function updateAuthIntervalCheckId(id) {
  return {
    type: UPDATE_CHECK_AUTH_INTERVAL_ID,
    payload: id
  };
}

export function fetchNewToken() {
  return {
    type: NEW_TOKEN_IS_FETCHING
  };
}
export function newTokenReceived() {
  return {
    type: NEW_TOKEN_RECEIVED
  };
}

export const setToken = (token = "") => {
  localStorage.setItem("id_token", token);
};

export const clearToken = () => {
  localStorage.removeItem("id_token");
};

export const getToken = () => {
  return localStorage.getItem("id_token") || "";
};

export const validateToken = (token = "") => {
  return (dispatch, getState) => {
    const googleAuthBaseURL =
      "https://www.googleapis.com/oauth2/v3/tokeninfo?id_token=";

    return dispatch(fetchApi(googleAuthBaseURL + token))
      .then(res => {
        if (res.status === 200) {
          return Promise.resolve(res.json());
        } else {
          return Promise.reject(new Error("Token Validation Error"));
        }
      })
      .catch(err => Promise.reject(err));
  };
};

export const validateWhitelistedEmail = (email = "") => {
  return (dispatch, getState) => {
    const encodedEmail = encodeURIComponent(email);
    return dispatch(
      fetchApi(`${getApiBaseUrl().GO.US}/ks/v1/support_user?email=${encodedEmail}`, true)
    )
      .then(res => {
        if (res.status === 200) {
          res.json()
            .then(res => {
              setSupportUser(res)
            })
          return Promise.resolve(true);
        } else {
          clearSupportUser()
          return Promise.resolve(false);
        }
      })
      .catch(err => {
        return Promise.resolve(false);
      });
  };
};

export const validateGoogleAuth = token => {
  return (dispatch, getState) => {
    // const token = GoogleAuth && GoogleAuth.tokenId;
    if (token) {
      setToken(token);
      dispatch(setAuthentication());
      return Promise.resolve(true);  
    } else {
      clearToken();
      dispatch(setAuthenticationFailed());
      return Promise.reject(false);
    }
    // return dispatch(validateToken(token))
    //   .then(res => {
    //     setToken(token);
    //     dispatch(setAuthentication());
    //     return res;
    //   })
    //   .catch(err => {
    //     clearToken();
    //     dispatch(setAuthenticationFailed());
    //     return Promise.reject(err);
    //   });
  };
};

export const checkAuth = () => {
  return (dispatch, getState) => {
    const token = getToken();
    const tokenExists = token && token.length > 0;
    const previousPath = window.location.pathname;

    if (!tokenExists) {
      const isAuthenticated = getState().Auth.isAuthenticated;
      const msg = isAuthenticated ? VALIDATION_CREDENTIAL_ERROR_MSG : '';
      dispatch(handleLogout(null, msg));
      return;
    }
    dispatch(setAuthentication());
    dispatch(push(previousPath));


    // dispatch(validateToken(token))
    //   .then(res => {
    //     dispatch(setAuthentication());
    //     dispatch(push(previousPath));
    //   })
    //   .catch(err => {
    //     dispatch(handleLogout(null, VALIDATION_CREDENTIAL_ERROR_MSG));
    //   });
  };
};

export const loadGoogleAuth = () => {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      if (window.gapi && !window.gapi.auth2) {
        window.gapi.load("auth2", function () {
          window.gapi.auth2
            .init({
              client_id: GOOGLE_CLIENT_ID
            })
            .then(() => {
              // console.log("Auth Enabled");
              return resolve();
            });
        });
      }
    });
  };
};

export const initAuth = () => {
  return (dispatch, getState) => {
    // console.log("Init Auth");
    dispatch(setAuthIntervalCheck());
    dispatch(setIdleIntervalCheck());
    // dispatch(loadGoogleAuth()).then(() => {
    //   dispatch(setIdleIntervalCheck());
    // });
  };
};

/* START - Timers */
const incrementIdleTimer = () => {
  internal_idle_counter_ms += 1000;
};
const resetIdleTimer = () => {
  internal_idle_counter_ms = 0;
};
const checkIdle = () => {
  return (dispatch, getState) => {
    const currentToken = getToken();

    const idToken = currentToken.length > 0 && jwtDecode(currentToken);
    const expDate = idToken.exp * 1000;
    const tokenTimeRemaining = expDate - Date.now();

    if (tokenTimeRemaining <= 0) {
      /* idle for awhile, never refreshed token so token expired. */
      dispatch(handleLogout(null, INACTIVITY_MSG));
      return;
    } else {
      /*  if the token has not expired, you are still logged in.
          Now do checks against idle or not
      */
      if (
        internal_idle_counter_ms <= IDLE_CHECK_THRESHOLD_MS &&
        tokenTimeRemaining <= TOKEN_EXPIRY_THRESHOLD_MS &&
        !getState().Auth.newTokenIsFetching
      ) {
        dispatch(fetchNewToken());
        const newToken = getToken() || "";
        setToken(newToken);
        dispatch(newTokenReceived());
        // const googleAuth = window.gapi.auth2.getAuthInstance();
        // const googleUser = googleAuth.currentUser.get();
        // googleUser.reloadAuthResponse().then(newAuth => {
          // const newToken = newAuth.id_token || "";
          // setToken(newToken);
          // dispatch(newTokenReceived());
        // });
      }
    }
  };
};

const CHECK_AUTH_INTERVAL_MS = 1000 * 60 * 15; // 15 mins
const IDLE_INCREMENT_INTERVAL_MS = 1000; // 1 second
const IDLE_CHECK_INTERVAL_MS = 1000 * 2; // 15 secs

const IDLE_CHECK_THRESHOLD_MS = 1000 * 60 * 15; // 15  mins
const TOKEN_EXPIRY_THRESHOLD_MS = 1000 * 60 * 30; // 30 mins
let internal_idle_counter_ms = 0;

export const setIdleIntervalCheck = () => {
  return (dispatch, getState) => {
    // Check idle timer
    window.setInterval(() => dispatch(checkIdle()), IDLE_CHECK_INTERVAL_MS);
    dispatch(checkIdle());

    // Increment idle timer
    window.setInterval(incrementIdleTimer, IDLE_INCREMENT_INTERVAL_MS);
    incrementIdleTimer();

    // Reset idle timer based on the following actions
    window.onmousemove = resetIdleTimer;
    window.onmousedown = resetIdleTimer;
    window.ontouchstart = resetIdleTimer;
    window.onclick = resetIdleTimer;
    window.onscroll = resetIdleTimer;
    window.onkeypress = resetIdleTimer;

    // console.log("Idle Checker Enabled");
  };
};

// export const clearAuthIntervalCheck = () => {
//   return (dispatch, getState) => {
//     dispatch(updateAuthIntervalCheckId(null));
//   };
// };

export const setAuthIntervalCheck = () => {
  return (dispatch, getState) => {
    const id = window.setInterval(
      () => dispatch(checkAuth()),
      CHECK_AUTH_INTERVAL_MS
    );
    dispatch(updateAuthIntervalCheckId(id));
    dispatch(checkAuth());

    // console.log("Auth Checker Enabled");
  };
};

// export const clearAuthIntervalCheck = () => {
//   return (dispatch, getState) => {
//     dispatch(updateAuthIntervalCheckId(null));
//   };
// };
/* END - Timers */

const initialState = {
  isAuthenticated: false,
  checkAuthIntervalID: null,
  newTokenIsFetching: false
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CLEAR_AUTHENTICATION]: (state, action) => {
    return { ...state, isAuthenticated: false };
  },
  [SET_AUTHENTICATION]: (state, action) => {
    return { ...state, isAuthenticated: true };
  },
  [UPDATE_CHECK_AUTH_INTERVAL_ID]: (state, action) => {
    return { ...state, checkAuthIntervalID: action.payload };
  },
  [NEW_TOKEN_IS_FETCHING]: (state, action) => {
    return { ...state, newTokenIsFetching: true };
  },
  [NEW_TOKEN_RECEIVED]: (state, action) => {
    return { ...state, newTokenIsFetching: false };
  },
  [CLEAR_STATE]: (state, action) => {
    return { initialState };
  }
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function authReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/containers/Auth/index.js